export default {
  ColorNeutralWhite: "#ffffff",
  ColorNeutral100: "#f3f3f3",
  ColorNeutral200: "#e5e5e5",
  ColorNeutral300: "#999ea3",
  ColorNeutral400: "#878c90",
  ColorNeutral500: "#5d6369",
  ColorNeutral600: "#43484d",
  ColorNeutral700: "#21212d",
  ColorNeutralBlack: "#000000",

  // ColorWhite, ColorGray, ColorBlack have been replaced with the 'ColorNeutral' ramp in design and will be removed in the future
  ColorWhite: "#ffffff",
  ColorGray100: "#f3f3f3",
  ColorGray300: "#e5e5e5",
  ColorGray500: "#43484d",
  ColorBlack: "#000000",

  ColorBlurple: "#f1f1ff",
  ColorBlurple50: "#eeedff",
  ColorBlurple100: "#dddcff",
  ColorBlurple200: "#bcb8ff",
  ColorBlurple300: "#9a95ff",
  ColorBlurple400: "#7971ff",
  ColorBlurple500: "#574eff",

  ColorSpace25: "#f8f8f8",
  ColorSpace50: "#f3f2f7",
  ColorSpace75: "#e9e9ef",
  ColorSpace100: "#d3d4e0",
  ColorSpace200: "#a6a9c2",
  ColorSpace300: "#7a7ea3",
  ColorSpace400: "#4e5385",
  ColorSpace500: "#212866",

  ColorMint100: "#d4f6ec",
  ColorMint200: "#a9ecda",
  ColorMint300: "#7de3c7",
  ColorMint400: "#52dab5",
  ColorMint500: "#27d0a2",

  ColorSun100: "#fff4cc",
  ColorSun200: "#ffe999",
  ColorSun300: "#ffdd66",
  ColorSun400: "#ffd233",
  ColorSun500: "#ffc700",

  ColorCarrot100: "#fee3d6",
  ColorCarrot200: "#fec8ac",
  ColorCarrot300: "#fdac83",
  ColorCarrot400: "#fd915a",
  ColorCarrot500: "#fc7530",

  // The ColorSneaker ramp has been replaced with the 'ColorSpace' ramp in design and will be removed in the future
  ColorSneaker50: "#f8f8fb",
  ColorSneaker100: "#f3f2f7",
  ColorSneaker300: "#7a7ea3",

  ColorGum100: "#fdf6f8",
  ColorGum200: "#faedf0",
  ColorGum300: "#f8e3e9",
  ColorGum400: "#f5dae1",
  ColorGum500: "#f3d1da",

  ColorPine: "#006351",
  ColorPine500: "#006351",
  ColorPine400: "#338274",
  ColorPine300: "#66a197",
  ColorPine200: "#99c1b9",
  ColorPine100: "#cce0dc",

  ColorLemon: "#ffec00",
  ColorLemon100: "#fffbcc",
  ColorLemon200: "#fff799",
  ColorLemon500: "#ffec00",

  ColorSky: "#dbf6fd",
  ColorSky100: "#f4fcfe",
  ColorSky200: "#edfafe",
  ColorSky500: "#d8f6fd",

  ColorEraserRed100: "#ff2c45",
  ColorEraserRed200: "#ef0b26",
  ColorEraserRed300: "#d4041d",
  ColorEraserRed400: "#ad081c",
} as const;
